module.exports = __webpack_public_path__ + "img/232.7331782f.png";